/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 查看线索询价信息+get
// 接口地址 /api/v1/used_car/ticket/enquiry/<int:enquiry_id>
Mock.mock(/used_car\/ticket\/enquiry\/\d+$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'car_info_id': 1, // # 询价时评估信息快照id
    'enquiry_id': 1, // # 询价id
    'ticket_id': 1, // # 线索id
    'status': 2, // # 值为 1 或 2
    'status_code': 'on_going', // # 值还以为 finished
    'status_name': '询价中', // # 值还可以为 已结束
    'started_at': '2012-12-12 12:12', // # 开始时间
    'finished_at': '2012-12-12 12:12', // # 结束时间
    'max_quote_price': 112000000, // # 最高
    'min_quote_price': 10450000, // # 最低
    'average_quote_price': 104500000, // # 平均报价
    'quote_count': 1, // # 报价次数
    'records|4': [ // # 报价记录 可能为一个空列表 排第一的为最高报价
      {
        'dealer_user_id': 45,
        'dealer_user_name': '车商组织名称',
        'dealer_user_mobile': '车商手机号',
        'dealer_user_city': '车商所在城市',
        'quote_price': 1555000000,
        'quote_time': '2012-12-12 12:12:22', // # 报价时间
        'expires_on': '2012-12-12' // # 有效期至
      }
    ]
  }
})

// 拍卖询价信息+get
// 接口地址 /api/v1/auctions/auction_car_enquiries/{enquiry_id}
Mock.mock(/auctions\/auction_car_enquiries\/\d+$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction_car_id': 1, // 车辆id
    'car_info_id': 1, // 车辆信息快照id
    'enquiry_id': 1, // 询价id
    'status': 1, // 状态码，1为询价中，2为已询价
    'status_code': 'on_going',
    'status_name': '询价中',
    'started_at': '2017-11-11  12:31', // 用于算报价有效期的结束时间(= 此字段 + 16d 以及把时分秒设为0)，如根据此字段值计算失效时间为 2017-11-27 0:0
    'finished_at': '2017-11-11  14:31', // 预计结束
    'max_quote_price': 12000000, // 最高报价，单位分
    'min_quote_price': 10000000, // 最低报价，单位分
    'average_quote_price': 11000000, // 平均报价，单位分
    'quote_count': 3, // 报价人数
    'matchable': true, // 可否提交撮合
    'match_status': 1, // 见约定, 0表示不在撮合中或不能撮合
    'match_status_code': 'created',
    'match_submit_before': '2018-5-24 12:00:21',
    'records|3': [{
      'dealer_user_id': 45,
      'dealer_user_name': '精品二手车', // 报价车商机构姓名
      'dealer_user_mobile': '13925506738', // 报价车商手机号
      'dealer_user_city': '东莞', // 报价车商所在城市
      'quote_price': 10260000, // 所报价格，单位分
      'quote_time': '14:01:00', // 报价时间
      'expires_on': '2017-1-1 14:01:00'
    }]
  }
})
